import Navbar from './components/Navbar';
import Hero from './components/Hero';
import IndexStrip from './components/IndexStrip';
import Stories from './components/Stories';
import Timeline from './components/Timeline';
import Cast from './components/Cast';
import Leaks from './components/Leaks';
import DeepDive from './components/DeepDive';
import Subscribe from './components/Subscribe';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-paper-50 text-ink-900">
      <Navbar />
      <main>
        <Hero />
        <IndexStrip />
        <Stories />
        <Timeline />
        <Cast />
        <Leaks />
        <DeepDive />
        <Subscribe />
      </main>
      <Footer />
    </div>
  );
}